export const FILTER_KEYS = {
  MANAGEMENT_COMPANIES: "management-companies",
  AUDIT_LOGS: "audit-logs",
  ADMIN_USERS: "admin-users",
  ANEEL_TARIFFS: "aneel-tariffs",
  ANEEL_TARIFF_IMPORT_HISTORY: "aneel-tariff-import-history",
  KNOWLEDGE_BASE: "knowledge-base",
  LEADS: "leads",
};
